<template>
  <h4 class="fs-5">Volo chiuso OK!</h4>
</template>

<script>
export default {
  name: "MessaggioChiusoOK"
}
</script>

<style scoped>

</style>